import { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { ItemDetail } from "./ItemDetail";
import Loader from "./Loader";
import { CartContext } from "../context/CartContext";

const ItemDetailContent = (props) => {
  window.scrollTo(0, 0);
  const { handleCartModal } = props;

  const onHandleCartModal = () => {
    handleCartModal();
  };

  const [itemDetail, setItem] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const { idProducto } = useParams();

  // CAMBIO: Traemos activeItems en lugar de items para la vista pública
  const { activeItems, isLoading: isContextLoading } = useContext(CartContext);

  useEffect(() => {
    // CAMBIO: Buscamos dentro de activeItems
    if (!isContextLoading && activeItems.length > 0) {
      const foundItem = activeItems.find(
        (item) => Number(item.id) === Number(idProducto),
      );

      setItem(foundItem);
      setIsLoading(false);
    } else if (!isContextLoading && activeItems.length === 0) {
      // Si ya cargó y no hay nada (o nada activo), dejamos de cargar
      setIsLoading(false);
    }
  }, [idProducto, activeItems, isContextLoading]);

  if (isLoading || isContextLoading) {
    return <Loader />;
  }

  return (
    <>
      <div className="detalle pe-md-3 ps-md-3">
        {itemDetail ? (
          <ItemDetail
            onHandleCartModal={onHandleCartModal}
            itemDetail={itemDetail}
          />
        ) : (
          <div className="container text-center mt-5">
            <h3>Producto no disponible</h3>
            <p>El producto solicitado no se encuentra activo o no existe.</p>
          </div>
        )}
      </div>
    </>
  );
};

export default ItemDetailContent;
